import { IPalletShipCommand, PalletShipCommandMode } from "./pallet-ship-command";
import moment from "moment/moment";

export class PalletManualShippingCommand implements IPalletShipCommand {
    public readonly mode = PalletShipCommandMode.Manual;
    private readonly _palletIdList: string[];
    private readonly _truckIdentifier: string;
    private readonly _pickingDate: moment.Moment;
    private readonly _containerSealNumber: string;
    private readonly _comment: string;

    constructor(palletIdList: string[], truckIdentifier: string, pickingDate: moment.Moment,
                containerSealNumber: string, comment: string) {
        this._palletIdList = palletIdList;
        this._truckIdentifier = truckIdentifier;
        this._pickingDate = pickingDate;
        this._containerSealNumber = containerSealNumber;
        this._comment = comment;
    }

    get palletIdList(): string[] {
        return this._palletIdList;
    }

    get truckIdentifier(): string {
        return this._truckIdentifier;
    }

    get pickingDate(): moment.Moment {
        return this._pickingDate;
    }

    get containerSealNumber(): string {
        return this._containerSealNumber;
    }

    get comment(): string {
        return this._comment;
    }
}
